<template>
  <div class="contents">
    <top>
      <el-button type="primary" @click="onSubmit">保存</el-button>
    </top>
    <div class="content-body">
      <div class="content-title">客服语言</div>
      <div class="content-subtitle">设置客服页面的语言</div>
      <div class="content-select">
        <el-select @change="changeLanguage" v-model="userInfo.language" size="small" placeholder="请选择语言">
          <el-option label="英语" value="en"></el-option>
          <el-option label="中文" value="zh"></el-option>
          <el-option label="日语" value="ja"></el-option>
          <el-option label="德语" value="de"></el-option>
          <el-option label="法语" value="fr"></el-option>
          <el-option label="西班牙语" value="es"></el-option>
          <el-option label="希伯来语" value="he"></el-option>
        </el-select>
      </div>
    </div>
    <div class="content-body">
      <div class="content-title">打招呼语</div>
      <div class="content-subtitle">设置打招呼语的语言</div>
      <div class="content-input">
        <el-input type="textarea" v-model="userInfo.greetMsg" maxlength="300" show-word-limit :rows="5"></el-input>
      </div>
    </div>
    <div class="content-body">
      <div class="content-title">固定回复</div>
      <div class="content-subtitle">设置固定回复的内容</div>
      <div class="content-input">
        <el-input type="textarea" v-model="userInfo.fixedMsg" maxlength="300" show-word-limit :rows="5"></el-input>
      </div>
      <!-- <div class="content-input">
        <div class="fixed-reply-input" v-for="(item, index) in fixedReply" :key="index">
          <el-input type="textarea" v-model="fixedReply[index]" maxlength="100" show-word-limit :rows="3" />
          <div class="fixed-reply-input-actions">
            <i class="el-icon-circle-plus-outline" style="cursor: pointer;font-size: 18px;" @click="addFixedReply(index)"></i>
            <i v-if="fixedReply.length > 1" class="el-icon-remove-outline" style="cursor: pointer;font-size: 18px;" @click="removeFixedReply(index)"></i>
          </div>
        </div>
      </div> -->
    </div>
    <message-dialog></message-dialog>
  </div>
</template>
<script>
import top from "./components/top.vue";
export default {
  data() {
    return {
      userInfo: {
        language: "",
        fixedMsg: "",
        greetMsg: "",
      },
      // helloTxt: "",
      // fixedReply: [""],
      // fixedReply: "",
    };
  },
  mounted() {
    this.loadUser();
  },
  components: {
    top,
  },
  methods: {
    // addFixedReply(index) {
    //   this.fixedReply.splice(index + 1, 0, "");
    // },
    // removeFixedReply(index) {
    //   if (this.fixedReply.length > 1) {
    //     this.fixedReply.splice(index, 1);
    //   }
    // },
    loadUser() {
      this.$http({
        url: "/customer/queryMessage",
        method: "post",
      }).then((res) => {
        console.log(res);
        this.userInfo = res;
        // this.helloTxt = this.userInfo.helloTxt;
        // this.fixedReply = this.userInfo.fixedReply;
      });
    },
    changeLanguage(language) {
      this.$http({
        url: "/customer/queryMessage",
        method: "post",
        params: { language },
      }).then((res) => {
        this.userInfo.fixedMsg = res.fixedMsg;
        this.userInfo.greetMsg = res.greetMsg;
      });
    },
    onSubmit() {
      this.$http({
        url: "/customer/settingMessage",
        method: "post",
        data: this.userInfo,
      }).then(() => {
        this.$store.dispatch("loadUser");
        this.$message.success("保存成功");
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.content-body {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px;
  .content-title {
    font-weight: 500;
    font-size: 15px;
  }
  .content-subtitle {
    font-size: 14px;
    color: #999999;
    margin-top: 10px;
  }
  .content-select {
    margin-top: 10px;
  }
  .content-input {
    margin-top: 10px;
    width: 300px;
  }
}
.fixed-reply-input {
  display: flex;
  margin-bottom: 10px;
  .fixed-reply-input-actions {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    margin-left: 10px;
    color: #999999;
  }
}
</style>
